export default {
	experiences: {
		title: 'الوظائف السابقة',
		jobName: 'اسم الوظيفة',
		companyName: 'اسم الشركة',
		address: 'العنوان',
		startDate: 'تاريخ البداية',
		endDate: 'تاريخ النهاية',
		quitRaison: 'سبب ترك الوظيفة',
		salary: 'آخر راتب',
	},

	recommend: {
		title: 'اذكر ثلاثة أشخاص للتزكية / معروف من قبل أشخاص يعملون في أماكن الأعمال السابقة',
		name: 'الاسم',
		job: 'المسمى الوظيفي',
		company: 'الشركة',
		phone: 'الرقم',
	},

	expectations: {
		jobYouWant: 'ما هي الوظيفة التي ترغب بها؟',
		jobName: 'اسم الوظيفة',
		addJob: 'إضافة وظيفة',
		expectSalary: 'الراتب المتوقع',
		haveRelativesWork: 'هل لديك اقاريب يعملون بالشركة؟',
		workNight: 'هل تمانع العمل بدوام ليلي؟',
		extraWorkOnVacations: 'هل تمانع العمل بوقت إضافي وفي أيام العطل والأعياد ؟',
	},

	validations: {
		nameRequire: 'اسم الوظيفة مطلوب، ',
		companyRequire: 'اسم الشركة مطلوب، ',
		startDateRequire: 'تاريخ البداية مطلوب، ',
		endDateRequire: 'تاريخ النهاية مطلوب، ',
		quitRaisonRequire: 'سبب ترك الوظيفة، ',
		datesOrder: 'تاريخ النهاية يجب ان يكون بعد تاريخ البداية، ',

		recommend: {
			nameRequire: 'الاسم مطلوب، ',
			jobRequire: 'المسمى الوظيفي مطلوب، ',
			companyRequire: 'الشركة مطلوب، ',
		},
	},
};
